import React, { useEffect, useRef, useState } from 'react';
import PropTypes from 'prop-types';
import { Flyout } from '@els/els-react--flyout';
import { ValidatedTextInput } from '@els/els-react--text-input';
import { useDispatch } from 'react-redux';
import { Button, ButtonWithIcon } from '@els/els-react--button';
import { updateGroupTitleAction } from '../../QueryletActions';

/** This component is visible in UI when we try to combine two query in query builder screen */
function GroupTitle({ groupTitle, nodelist }) {
  const [editMode, setEditMode] = useState(false);

  const [title, setTitle] = useState(groupTitle.groupName);
  const groupNameRef = useRef(null);

  const dispatch = useDispatch();
  const ariaText = editMode ? 'Update Group Name' : 'Edit Group Name';

  const isTitleValid = (value) => value && value.trim().length >= 3 && value.trim().length <= 20;

  useEffect(() => {
    if (editMode && groupNameRef.current) {
      groupNameRef.current.focus();
    }
  }, [editMode]);

  const renameGroup = () => {
    if (editMode) {
      if (isTitleValid(title)) {
        dispatch(updateGroupTitleAction(groupTitle, title.trim(), nodelist));
        setEditMode(false);
      }
    } else {
      setEditMode(true);
    }
  };

  return (
    <div className="ql__prop__title ql__prop__group-title">
      {editMode ? (
        <ValidatedTextInput
          value={title}
          inputRef={groupNameRef}
          label={`Group Name ${title}`}
          min={3}
          max={20}
          data-e2e="group-title-input"
          shouldHideLabel
          required
          validator="none"
          className="ql__prop__group-title__input"
          onChange={(e) => setTitle(e?.target?.value)}
        />
      ) : (
        <span className="cursor-move">
          {title.length > 12 ? (
            <Flyout
              className="patent-content__processing-mode-flyout"
              flyout={title}
              shouldCloseOnESC
              placement="top-start"
              trigger="hover"
              pointerType="primary">
              <Button data-e2e="group-title-flyout-button" className="ql__prop--name text-flyout u-els-anchorize">
                {title}
              </Button>
            </Flyout>
          ) : (
            <span className="ql__prop--name">{title}</span>
          )}
        </span>
      )}
      <Flyout
        trigger="hover"
        flyout={<span aria-hidden="true">{editMode ? 'Save' : 'Edit group name'}</span>}
        placement="bottom"
        theme="simple">
        <ButtonWithIcon
          sprite={editMode ? 'Checkmark' : 'Edit'}
          type="link"
          id="querybuilder-update-groupname"
          iconOnly
          data-e2e="update-group-name-button"
          aria-label={ariaText}
          onClick={() => {
            renameGroup();
          }}>
          {ariaText}
        </ButtonWithIcon>
      </Flyout>
    </div>
  );
}

GroupTitle.propTypes = {
  groupTitle: PropTypes.object,
  nodelist: PropTypes.array,
};
export default GroupTitle;
